const noPermissions = {
    canCreate: false,
    canRead: false,
    canUpdate: false,
    canDelete: false,
};
export const unrestrictedCRUD = {
    canCreate: true,
    canRead: true,
    canUpdate: true,
    canDelete: true,
};
export const defaultPermissions = {
    exactAttendance: noPermissions,
    attendance: {
        content: {},
        header: {
            export: {
                dailyTotals: noPermissions,
                detailedBreakdown: noPermissions,
            },
        },
    },
    attendanceDetails: {
        content: {
            cell: {
                attendance: noPermissions,
                schedule: noPermissions,
                breaks: noPermissions,
            },
            actions: {
                addAttendance: noPermissions,
                addPersonalAttendance: noPermissions,
            },
            totals: {
                bankHours: noPermissions,
                schedule: noPermissions,
                contracted: noPermissions,
                attended: noPermissions,
                breaks: noPermissions,
            },
        },
        header: {
            staffSelector: noPermissions,
            goToSchedule: noPermissions,
        },
    },
    childAttendance: {
        content: {},
        header: {
            export: {
                kinderConnect: noPermissions,
                milkReport: noPermissions,
                exportCsv: noPermissions,
            },
        },
    },
    customRegistrationForms: {
        enrollment: noPermissions,
        interest: noPermissions,
        ofChild: {
            responses: noPermissions,
            status: noPermissions,
        },
        manageForm: {
            ...noPermissions,
            canCreateFollowUpForm: false,
            duplicate: noPermissions,
            name: noPermissions,
            manageSubmissionKeys: noPermissions,
            publish: noPermissions,
            responses: noPermissions,
            sendEmails: noPermissions,
            share: noPermissions,
            successMessage: noPermissions,
            toggleNotifications: noPermissions,
            confirmationEmail: noPermissions,
            unpublish: noPermissions,
            viewResponses: noPermissions,
            feeAmount: noPermissions,
        },
        manageFormBySiteSetId: {
            ...noPermissions,
            canCreateFollowUpForm: false,
            duplicate: noPermissions,
            name: noPermissions,
            manageSubmissionKeys: noPermissions,
            publish: noPermissions,
            responses: noPermissions,
            sendEmails: noPermissions,
            share: noPermissions,
            successMessage: noPermissions,
            toggleNotifications: noPermissions,
            confirmationEmail: noPermissions,
            unpublish: noPermissions,
            viewResponses: noPermissions,
            feeAmount: noPermissions,
        },
        registration: noPermissions,
    },
    forms: {
        content: {},
        header: {
            newForm: noPermissions,
        },
    },
    fte: noPermissions,
    inquiries: {
        content: {
            enrollChild: noPermissions,
            holdPlace: noPermissions,
            releasePlace: noPermissions,
        },
        header: {
            downloadCsv: {
                ...noPermissions,
                canRead: false,
            },
            newInquiry: {
                ...noPermissions,
                canRead: false,
            },
        },
    },
    institution: {
        employees: {
            ...noPermissions,
            canManageRolesAndPermissions: false,
        },
    },
    schedules: noPermissions,
    shiftPlanner: {
        general: noPermissions,
        shift: {
            draft: noPermissions,
            published: noPermissions,
        },
    },
    staffAttendance: noPermissions,
    staffAttendanceByEmployee: noPermissions,
    staffHoursPage: {
        content: {
            bankHours: noPermissions,
            approveAndLockHours: noPermissions,
            unlockHours: noPermissions,
            approvalView: noPermissions,
        },
        header: { seeChangeLog: noPermissions, export: noPermissions, filters: noPermissions },
    },
    staffHoursSettingsPage: {
        header: {
            exactAttendanceOptIn: noPermissions,
        },
        content: {},
    },
    staffHours: noPermissions,
    staffOverview: {
        content: {
            cells: {
                employee: {
                    bankHours: noPermissions,
                    contractedHours: noPermissions,
                },
                day: {
                    scheduled: noPermissions,
                },
                total: {
                    scheduled: noPermissions,
                },
            },
        },
        header: {},
    },
    staffPlanner: {
        content: {
            workAvailability: noPermissions,
            contractedHours: noPermissions,
            scheduledHours: noPermissions,
        },
        header: {
            copyShifts: noPermissions,
            newShift: noPermissions,
            deleteShift: noPermissions,
            bulkDeleteShift: noPermissions,
        },
    },
    staffProfile: {
        scheduleWidget: {
            ...noPermissions,
            staffRotasButton: noPermissions,
            staffHoursButton: noPermissions,
            weeklyDetailsButton: noPermissions,
        },
        contract: {
            page: noPermissions,
            bankHours: noPermissions,
            changeLog: noPermissions,
            weeklyHours: noPermissions,
            workAvailability: noPermissions,
        },
        credentialAssignment: noPermissions,
        qualificationTypeAssignment: noPermissions,
    },
    staffSchedule: {
        content: {},
        header: {
            export: {
                staffingCSV: noPermissions,
            },
        },
    },
    staffScheduleSettings: {
        editStaffSchedule: noPermissions,
    },
    subtypes: {
        ...noPermissions,
    },
    subtypesV2: {
        ...noPermissions,
    },
    workTags: noPermissions,
    staffRatioReport: {
        header: {},
        content: {
            scheduledStaff: noPermissions,
        },
    },
    staffLeaveV2: noPermissions,
    staffLeaveSettingsV2: noPermissions,
    unrestricted: unrestrictedCRUD,
    occupancyBudgets: noPermissions,
    staffOverviewPage: {
        header: {
            addEmployee: noPermissions,
            manageRolesAndPermissions: noPermissions,
        },
        content: {
            canAssignRoles: noPermissions,
        },
    },
    staffLeaveV2Page: {
        completed: noPermissions,
        pending: noPermissions,
        approveLeave: noPermissions,
        rejectLeave: noPermissions,
        totals: noPermissions,
        csvExportOverview: noPermissions,
        changeLog: noPermissions,
        csvExportTotals: {
            totals: noPermissions,
            details: noPermissions,
        },
        bradfordFactor: noPermissions,
        siteSet: {
            completed: noPermissions,
            pending: noPermissions,
            totals: noPermissions,
        },
        pendingTab: noPermissions,
    },
    staffLeaveV2Conflicts: noPermissions,
    onboardingTeamContacts: noPermissions,
    resourceLibraryPage: {
        content: {
            editResource: noPermissions,
        },
        header: {
            addResource: noPermissions,
        },
    },
    taskManagement: {
        base: noPermissions,
        canTogglePublishedState: noPermissions,
    },
    qualificationsSettings: {
        header: {},
        content: {
            credentials: noPermissions,
            qualificationTypes: noPermissions,
        },
    },
    contractTemplateManagementFlags: noPermissions,
    careContractManagementFlags: {
        ...noPermissions,
        canViewFileUrls: false,
        canCreateFromTemplate: false,
    },
    ageGroups: {
        canRead: false,
        canEdit: false,
        canEditCapacityFactor: false,
        settings: {
            canRead: false,
            canEdit: false,
            canEditCapacityFactor: false,
        },
    },
    careGroups: {
        canRead: false,
        canEdit: false,
        settings: {
            canRead: false,
            canEdit: false,
        },
    },
    careRules: {
        canRead: false,
        canEdit: false,
    },
    childAdditionalNeedTypes: {
        canView: false,
        canEdit: false,
    },
    childAdditionalNeedsAssignment: {
        canView: false,
        canEdit: false,
    },
    childAdditionalNeedsOverview: {
        canView: false,
    },
    childAdditionalNeedsList: {
        canView: false,
    },
    careSummary: {
        canViewGraph: false,
        canViewIssues: false,
        canViewCsv: false,
    },
    ratioInfo: {
        canViewChildrenAttending: false,
        canViewStaffAttending: false,
        canViewChildrenExpected: false,
        canViewStaffExpected: false,
        canViewRatioInfo: false,
        canViewCareRulesSummary: false,
    },
    childBookingsNotice: {
        canRead: false,
    },
    workTagColorsCoachMark: {
        canRead: false,
    },
};
